import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountingNumber',
  standalone: false,
})
export class AccountingNumberPipe implements PipeTransform {
  transform(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '0.00';
    }

    const num = typeof value === 'string' ? Number(value.toString().replace(/,/g, '')) : Number(value);
    if (isNaN(num)) {
      return '0.00';
    }

    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }
}


